export const Post = async (url,clientId, body) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-platform' : ' true',
        'clientId' : clientId,
        'idToken' : localStorage.getItem('user')
      },
      body: JSON.stringify(body),
    });
    if(response.status === 401) {
      localStorage.removeItem('user');
      window.location.href = '/unauthorized';
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data; // Return the response data
  } catch (error) {
    console.error('Error in POST request:', error.message);
    throw error; // Rethrow the error for the caller to handle
  }
};

export default Post;